export default "/fonts/vendor/@fontsource/space-mono/files/space-mono-all-400-normal.woff?151becc475d494997f4ad9b3f320f1b2";